var map = {
  "./cs.json": [
    "TsN",
    [
      13
    ]
  ],
  "./en.json": [
    "mF",
    [
      "kz"
    ]
  ],
  "./pl.json": [
    "Oil",
    [
      "wc"
    ]
  ],
  "./ru.json": [
    "T5e",
    [
      "9m1"
    ]
  ],
  "./tr.json": [
    "py",
    [
      "39l"
    ]
  ],
  "./ja.json": [
    "w1N",
    [
      "aym"
    ]
  ],
  "./zh.json": [
    "Bj9",
    [
      "ng"
    ]
  ],
  "./pt-br.json": [
    "rp",
    [
      "1h"
    ]
  ],
  "./de.json": [
    "gC",
    [
      "uq"
    ]
  ],
  "./es.json": [
    "UBS",
    [
      "aou"
    ]
  ],
  "./fr.json": [
    "al8",
    [
      "0f"
    ]
  ],
  "./it.json": [
    "ZLp",
    [
      "vsg"
    ]
  ],
  "./ko.json": [
    "VaR",
    [
      "nw"
    ]
  ],
  "./pt.json": [
    "nM",
    [
      "hn"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "Me";
module.exports = __rspack_async_context;
